__turbopack_context__.v({
  "chevron": "EntriesAndStats-module__UDoniW__chevron",
  "choosePlanBox": "EntriesAndStats-module__UDoniW__choosePlanBox",
  "choosePlanContainer": "EntriesAndStats-module__UDoniW__choosePlanContainer",
  "choosePlanDesktopSkeleton": "EntriesAndStats-module__UDoniW__choosePlanDesktopSkeleton",
  "choosePlanSection": "EntriesAndStats-module__UDoniW__choosePlanSection",
  "container": "EntriesAndStats-module__UDoniW__container",
  "countdownBox": "EntriesAndStats-module__UDoniW__countdownBox",
  "countdownContainer": "EntriesAndStats-module__UDoniW__countdownContainer",
  "desktopOnly": "EntriesAndStats-module__UDoniW__desktopOnly",
  "entries": "EntriesAndStats-module__UDoniW__entries",
  "entriesContainer": "EntriesAndStats-module__UDoniW__entriesContainer",
  "entriesContainerCountdownOnly": "EntriesAndStats-module__UDoniW__entriesContainerCountdownOnly",
  "iconContainer": "EntriesAndStats-module__UDoniW__iconContainer",
  "resultsLinkWrapper": "EntriesAndStats-module__UDoniW__resultsLinkWrapper",
  "separator": "EntriesAndStats-module__UDoniW__separator",
  "separatorMobileOnly": "EntriesAndStats-module__UDoniW__separatorMobileOnly",
  "statFooter": "EntriesAndStats-module__UDoniW__statFooter",
  "statHeader": "EntriesAndStats-module__UDoniW__statHeader",
  "statLink": "EntriesAndStats-module__UDoniW__statLink",
  "statTotal": "EntriesAndStats-module__UDoniW__statTotal",
  "statsContainer": "EntriesAndStats-module__UDoniW__statsContainer",
  "textWhite": "EntriesAndStats-module__UDoniW__textWhite",
  "ticketEntriesContainer": "EntriesAndStats-module__UDoniW__ticketEntriesContainer",
  "ticketIcon": "EntriesAndStats-module__UDoniW__ticketIcon",
  "titleContainer": "EntriesAndStats-module__UDoniW__titleContainer",
  "winWithFriendsBadge": "EntriesAndStats-module__UDoniW__winWithFriendsBadge",
});
